import * as z from "zod";
import { null as zNull } from "zod";

/** Completeness of the customs fields (HS code, country of origin,
 * manufacturer/MID) that drive cross-border landed-cost quoting, across the
 * authenticated team's Shopify catalog. Powers the readiness progress bar. */
export const getCrossBorderReadiness = {
  name: "getCrossBorderReadiness" as const,
  input: zNull(),
  output: z.object({
    total: z.number(),
    valid: z.number(),
    readinessPercent: z.number(),
    missingHsCode: z.number(),
    missingOriginCountry: z.number(),
    missingManufacturerId: z.number(),
  }),
};

export type CrossBorderReadiness = z.infer<
  typeof getCrossBorderReadiness.output
>;
